import { render } from "./PatientsDatatableTDRecordStatus.vue?vue&type=template&id=4fc17d60"
import script from "./PatientsDatatableTDRecordStatus.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDRecordStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__